import { render, staticRenderFns } from "./CivilStatusEdit.vue?vue&type=template&id=28c4b766"
import script from "./CivilStatusEdit.vue?vue&type=script&lang=js"
export * from "./CivilStatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports